import RefreshIcon from "@mui/icons-material/Refresh";
import { Box, TextField } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";

const Captcha = forwardRef(({ value, onChange, error, helperText }, ref) => {
  const [captchaText, setCaptchaText] = useState("");
  const [canvasKey, setCanvasKey] = useState(0);

  useImperativeHandle(ref, () => ({
    validate: () => {
      const trimmedValue = (value || "").trim().toUpperCase();
      const trimmedCaptcha = (captchaText || "").trim().toUpperCase();
      console.log("Validating captcha:", {
        value: trimmedValue,
        captcha: trimmedCaptcha,
        match: trimmedValue === trimmedCaptcha,
      });
      return trimmedValue === trimmedCaptcha;
    },
    refresh: () => {
      generateCaptcha();
    },
    getCaptchaText: () => captchaText,
  }));

  const generateCaptcha = () => {
    const chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let text = "";
    for (let i = 0; i < 5; i++) {
      text += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptchaText(text);
    setCanvasKey((prev) => prev + 1);
    if (onChange) {
      onChange("");
    }
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  useEffect(() => {
    drawCaptcha();
  }, [captchaText, canvasKey]);

  const drawCaptcha = () => {
    const canvas = document.getElementById(`captcha-canvas-${canvasKey}`);
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Background
    ctx.fillStyle = "#f0f0f0";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Add noise lines
    for (let i = 0; i < 5; i++) {
      ctx.strokeStyle = `rgba(${Math.random() * 255},${Math.random() * 255},${
        Math.random() * 255
      },0.3)`;
      ctx.beginPath();
      ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.stroke();
    }

    // Draw captcha text
    ctx.font = "bold 32px Arial";
    ctx.textBaseline = "middle";

    for (let i = 0; i < captchaText.length; i++) {
      const char = captchaText[i];
      const x = 20 + i * 30;
      const y = 30 + (Math.random() - 0.5) * 10;
      const rotation = (Math.random() - 0.5) * 0.4;

      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(rotation);
      ctx.fillStyle = `rgb(${Math.random() * 100},${Math.random() * 100},${
        Math.random() * 100
      })`;
      ctx.fillText(char, 0, 0);
      ctx.restore();
    }

    // Add noise dots
    for (let i = 0; i < 50; i++) {
      ctx.fillStyle = `rgba(${Math.random() * 255},${Math.random() * 255},${
        Math.random() * 255
      },0.3)`;
      ctx.fillRect(
        Math.random() * canvas.width,
        Math.random() * canvas.height,
        2,
        2
      );
    }
  };

  const validateCaptcha = () => {
    return value === captchaText;
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          mb: 1.5,
          flexDirection: { xs: "column", sm: "row" },
        }}
      >
        <Box
          sx={{
            border: "2px solid #e0e0e0",
            borderRadius: "8px",
            padding: "8px",
            backgroundColor: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: { xs: "100%", sm: "auto" },
            maxWidth: { xs: "220px", sm: "none" },
          }}
        >
          <canvas
            id={`captcha-canvas-${canvasKey}`}
            width="200"
            height="60"
            style={{ display: "block", maxWidth: "100%" }}
          />
        </Box>

        <IconButton
          onClick={generateCaptcha}
          color="primary"
          size="small"
          sx={{
            backgroundColor: "#f5f5f5",
            "&:hover": {
              backgroundColor: "#e0e0e0",
            },
          }}
        >
          <RefreshIcon />
        </IconButton>
      </Box>

      <TextField
        label="کد امنیتی را وارد کنید"
        variant="outlined"
        fullWidth
        value={value}
        onChange={(e) => onChange && onChange(e.target.value.toUpperCase())}
        error={error}
        helperText={helperText}
        placeholder="کد تصویر را وارد کنید"
        inputProps={{
          maxLength: 5,
          style: { textTransform: "uppercase" },
        }}
      />
    </Box>
  );
});

export { Captcha };
export default Captcha;
